import EarnedWageAccessScheduleEditPage from '@/common/pages/(private)/(dashboard)/ewa/schedule/edit';

export default function Page() {
  return <EarnedWageAccessScheduleEditPage />;
}
